// src/hooks/useApi.js
import { useState, useCallback } from "react";
import { enqueueSnackbar } from "notistack";
import { handleApiError } from "../utils/errorHandler";

const useApi = (apiFunc, { showSuccess = true, showError = true } = {}) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  const execute = useCallback(
    async (...params) => {
      setLoading(true);
      setError(null);
      try {
        const response = await apiFunc(...params);
        setData(response?.data?.data ?? response?.data);
        
        // Handle success messages - support both string and object formats
        if (showSuccess && response?.data?.message) {
          const msg = response.data.message;
          if (typeof msg === 'string') {
            // Message is a string: "Success message here"
            enqueueSnackbar(msg, { variant: "success" });
          } else if (msg?.success) {
            // Message is an object: { success: "Success message here" }
            enqueueSnackbar(msg.success, { variant: "success" });
          }
        }
        
        return response;
      } catch (err) {
        setError(err);
        if (showError) handleApiError(err);
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [apiFunc, showSuccess, showError]
  );

  return { execute, loading, data, error };
};

export default useApi;
